export default __webpack_public_path__ + "static/media/Sustainability MMP Article 2022 01 20b.26d9545b.pdf";